"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStreamer = exports.ObservableMessageType = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const platform_sdk_1 = require("@pureweb/platform-sdk");
const platform_sdk_2 = require("@pureweb/platform-sdk");
const log = platform_sdk_2.LoggerProvider.getLogger('platform');
var ObservableMessageType;
(function (ObservableMessageType) {
    ObservableMessageType[ObservableMessageType["QualityControlOwnership"] = 0] = "QualityControlOwnership";
    ObservableMessageType[ObservableMessageType["Response"] = 1] = "Response";
    ObservableMessageType[ObservableMessageType["Command"] = 2] = "Command";
    ObservableMessageType[ObservableMessageType["FreezeFrame"] = 3] = "FreezeFrame";
    ObservableMessageType[ObservableMessageType["UnfreezeFrame"] = 4] = "UnfreezeFrame";
})(ObservableMessageType = exports.ObservableMessageType || (exports.ObservableMessageType = {}));
/**
 * Creates a WebRTC-based Streaming Interface.
 * @param signallingConnection The signalling connection to facilitate peer connection construction.
 * @param options Optional options to customize the streamer
 */
function useStreamer(platform, launchRequest, options, contributionFilter) {
    if (!options) {
        options = platform_sdk_1.DefaultStreamerOptions;
    }
    const [status, setStatus] = react_1.useState(platform_sdk_1.StreamerStatus.New);
    const [videoStream, setVideoStream] = react_1.useState();
    const [audioStream, setAudioStream] = react_1.useState();
    const [inputEmitter, setInputEmitter] = react_1.useState(new platform_sdk_1.InputEmitter(null));
    const [messageSubject, setMessageSubject] = react_1.useState(new rxjs_1.Subject());
    const [consumed, setConsumed] = react_1.useState(false);
    const [contributionRegistry, setContributionRegistry] = react_1.useState();
    react_1.useEffect(() => {
        if (platform.agent && !contributionRegistry) {
            setContributionRegistry(new platform_sdk_1.ContributionRegistry(platform));
        }
    }, [platform.agent]);
    react_1.useEffect(() => {
        if (consumed && launchRequest) {
            launchRequest.service();
        }
    }, [consumed]);
    react_1.useEffect(() => {
        if (!platform.agent || !contributionRegistry) {
            return;
        }
        let statusSubscription;
        const subscription = contributionRegistry.listen('WEBRTC_UNREAL_STREAM').subscribe((next) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            if (next.type === platform_sdk_1.ContributionTypes.CONTRIBUTION) {
                if (consumed) {
                    log.warn('received secondary WEBRTC_UNREAL_STREAM contribution, ignoring: ' + next);
                    return;
                }
                if (next.contribution && contributionFilter ? contributionFilter(next.contribution) : true) {
                    statusSubscription = (_a = next.contribution) === null || _a === void 0 ? void 0 : _a.status.subscribe((nextStatus) => {
                        setStatus(nextStatus);
                    }, (err) => {
                        log.error(err);
                    }, () => {
                        setStatus(platform_sdk_1.StreamerStatus.Withdrawn);
                    });
                    try {
                        const elements = yield ((_b = next.contribution) === null || _b === void 0 ? void 0 : _b.consume(options));
                        if (elements) {
                            setAudioStream(elements.audioStream);
                            setVideoStream(elements.videoStream);
                            setInputEmitter(elements.inputEmitter);
                            setMessageSubject(elements.messageReceiver);
                            setConsumed(true);
                        }
                    }
                    catch (err) {
                        log.error(err);
                    }
                }
            }
            else if (next.type === platform_sdk_1.ContributionTypes.WITHDRAWAL) {
                setVideoStream(null);
                setAudioStream(null);
                setInputEmitter(null);
                messageSubject.complete();
                (_c = next.contribution) === null || _c === void 0 ? void 0 : _c.close();
            }
        }), (err) => {
            log.error(err);
            setStatus(platform_sdk_1.StreamerStatus.Failed);
        });
        return () => {
            subscription.unsubscribe();
            if (statusSubscription != null) {
                statusSubscription.unsubscribe();
            }
        };
    }, [platform.agent, contributionRegistry]);
    return [status, inputEmitter, videoStream, audioStream, messageSubject];
}
exports.useStreamer = useStreamer;
//# sourceMappingURL=StreamerHook.js.map